export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";